import { Field } from '@progress/kendo-react-form';
import { FC, useMemo } from 'react';

import { dateTimeUtils } from '../../../../utils';
import { requiredValidator } from '../../validators/validator';
import { FormDropDown } from './FormDropdown';
import { CustomTextFormField } from '../text-form-field/CustomTextFormField';

interface IProps {
  edit: boolean;
  name: string;
  label: string;
  required: boolean;
}

export const FormTimeZoneDropdown: FC<IProps> = ({ edit, name, label, required }) => {
  const timezones = useMemo(() => dateTimeUtils.getUITimezones(), []);

  return edit ? (
    <Field
      name={name}
      label={label}
      dataItemKey='ianaName'
      textField='displayName'
      data={timezones}
      valueMap={(value: { ianaName: string }) => value?.ianaName}
      required={required}
      validator={required ? requiredValidator : undefined}
      component={FormDropDown}
    />
  ) : (
    <Field
      name={name}
      label={label}
      component={CustomTextFormField}
      customTextGetter={(v: string) => timezones.find((x) => x.ianaName === v)?.displayName}
    />
  );
};
